<template>
  <div class="status-prompt">
    <p class="status-prompt__title">{{ title }}</p>
    <p class="status-prompt__subtitle">{{ subtitle }}</p>
    <div class="status-prompt__actions">
      <button class="status-prompt__action" @click="actionHandler(ACTIONS.COMPLETE_STATUS_PROMPT)">
        {{ $t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.ACTION.EDIT') }}
      </button>
    </div>
  </div>
</template>

<script>
import { PROMPT_FLOW_TITLE } from '@/config/TRANSLATION_CONSTANTS';
import dashboardCardMixin from '@/mixins/dashboardCardMixin';

export default {
  name: 'StatusPromptCard',
  mixins: [dashboardCardMixin],
  props: {
    deal: {
      type: Object,
      required: true,
    },
    cardDynamicData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      return PROMPT_FLOW_TITLE[this.cardDynamicData.prompt_flow?.toUpperCase()];
    },
    subtitle() {
      const propertyPromptFlow = [
        'first_appointment',
        'cancel_first_appointment',
        'notary_appointment',
        'close_broker_order_general_reminder',
      ];

      const showPropertyAddress =
        propertyPromptFlow.includes(this.cardDynamicData.prompt_flow) ||
        !this.cardDynamicData.appointment_participant;

      if (showPropertyAddress) {
        return this.deal.property.address.formatted_address;
      }

      if (!this.cardDynamicData.appointment_from) {
        return this.$t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.PARTICIPANT_NAME', {
          name: this.cardDynamicData.appointment_participant,
        });
      }

      const formattedDate = new Date(this.cardDynamicData.appointment_from);

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      };

      const [date, time] = new Intl.DateTimeFormat('de-DE', options)
        .format(formattedDate)
        .split(',');

      return this.$t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.APPOINTMENT_DETAILS', {
        name: this.cardDynamicData.appointment_participant,
        date,
        time,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.status-prompt {
  $root: &;

  &__title {
    @include fontGroup(100, 600);
    color: $primary-color;
    margin-bottom: $sp-s;
  }

  &__subtitle {
    @include fontGroup(90, 400);
    color: $primary-color;
  }

  &__actions {
    display: flex;
  }

  &__action {
    position: relative;
    border: none;
    text-align: left;
    border-radius: $sp-xs;
    cursor: pointer;
    padding: $sp-s ($sp-m - $sp-xs);
    background-color: getShade($secondary-color, 120);
    @include fontGroup(90, 400);
    margin-right: $sp-s + $sp-xs;
    margin-top: $sp-s + $sp-xs;
    color: $white;
    height: $sp-l;
    line-height: $sp-m;

    &:hover {
      @include elevation(2);
    }

    &--secondary {
      border: 1px solid getShade($secondary-color, 120);
      color: getShade($secondary-color, 120);
      background-color: $white;
    }

    #{$root}__badge {
      position: absolute;
      margin: 0;
      right: -8px;
      top: -11px;
      background-color: getShade($error-color, 50);
      color: $error-color;
      @include fontGroup(80, 400);
      padding: $sp-xxs ($sp-xxs + $sp-xs);
      border-radius: $sp-xxs + $sp-s;
      height: 20px;

      &--secondary {
        color: $primary-color;
        background-color: getShade($quaternary-color, 50);
      }
    }
  }
}
</style>
